import api from "../api/axios";

const PromissoryNoteService = {
  getPromissoryNotes: async (status, type) => {
    const response = await api.get("/PromissoryNote", { params: { status, type } });
    return response.data;
  },
  endorsePromissoryNote: async (data) => {
    const response = await api.post("/PromissoryNote/endorse", data);
    return response.data;
  },
  updateStatus: async (data) => {
    const response = await api.post("/PromissoryNote/update-status", data);
    return response.data;
  },
  createPromissoryNote: async (data) => {
    const response = await api.post("/PromissoryNote", data);
    return response.data;
  }
};

export default PromissoryNoteService;
